import { computed, Injectable, signal } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class LoadingSpinnerService {
  private readonly _activeRequests = signal(0)
  private readonly _message = signal('')
  private readonly _title = signal('')
  readonly loading = computed(() => this._activeRequests() > 0)
  readonly message = this._message.asReadonly()
  readonly title = this._title.asReadonly()

  show(message?: string, title?: string) {
    this._activeRequests.update((count) => count + 1)
    if (message) {
      this._message.set(message)
    }
    if (title) {
      this._title.set(title)
    }
  }

  hide() {
    this._activeRequests.update((count) => count - 1)
    if (this._activeRequests() <= 0) {
      this._message.set('')
      this._title.set('')
      this._activeRequests.set(0)
    }
  }
}
